import {
  EmptyState,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components';
import type { AdvancedSearchResponse } from '@/shared/api';

interface Props {
  response: AdvancedSearchResponse;
  onPageChange: (page: number) => void;
  isFetching: boolean;
}

export function ResultsTable({ response, onPageChange, isFetching }: Props) {
  const { columns, results } = response;

  if (results.total === 0) {
    return (
      <EmptyState
        title="Keine Treffer"
        description="Passe die Bedingungen an oder erweitere den Scope."
      />
    );
  }

  return (
    <div className={isFetching ? 'opacity-60 transition-opacity' : undefined}>
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((col) => (
              <TableHead key={col}>{col}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {results.items.map((row) => (
            <TableRow key={row.id}>
              {columns.map((col) => (
                <TableCell key={col}>{formatCell(row.cells[col])}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination
        page={results.page}
        pageSize={results.pageSize}
        total={results.total}
        onPageChange={onPageChange}
      />
    </div>
  );
}

function formatCell(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';
  return String(value);
}
